import React, { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';
import PrivateRoute from '@/components/auth/PrivateRoute';
import { MENU } from '@/constants/menuCodes';

const ResourceReservationPage = lazy(() => import('@/pages/resource/ResourceReservationPage'));
const ResourceAssetPage = lazy(() => import('@/pages/resource/ResourceAssetPage'));
const ResourceUsagePage = lazy(() => import('@/pages/resource/ResourceUsagePage'));

/** 자원관리 모듈 라우트 */
const resourceRoutes = [
  // /resource 는 메뉴 트리의 네임스페이스일 뿐이므로 예약 화면으로 보낸다.
  <Route key="resource-root" path="resource" element={<Navigate to="/resource/reservations" replace />} />,

  <Route
    key="resource-reservations"
    path="resource/reservations"
    element={<PrivateRoute menuCode={MENU.RES_RESERVATION}><ResourceReservationPage /></PrivateRoute>}
  />,
  <Route
    key="resource-usage"
    path="resource/usage"
    element={<PrivateRoute menuCode={MENU.RES_USAGE}><ResourceUsagePage /></PrivateRoute>}
  />,
  <Route
    key="resource-assets"
    path="resource/assets"
    element={<PrivateRoute menuCode={MENU.RES_ASSET}><ResourceAssetPage /></PrivateRoute>}
  />,
];

export default resourceRoutes;
